import AtcClassifications from './AtcClassifications'
import Content from './Content'
import ContentEdit from './Content/editForm'
import InteractionsType from './InteractionsType'
import Laboratories from './Laboratories'
import Medications from './Medications'
import MedicationClassification from './MedicationClassification'
import NotFound from './NotFound'
import NotPermission from './NotPermission'
import Login from './Login'
import Users from './Users'
import Severities from './Severities'
import Specialities from './Specialities'
import Keywords from './Keywords'
import ResetPassword from './ResetPassword'
import Authors from './Authors'
import Ratings from './Ratings'
import RatingDetails from './Ratings/RatingDetails'
import PreRegistration from './PreRegistration'
import Profiles from './Profiles'
import MedicationsTypes from './MedicationsTypes'
import DcbNames from './DcbNames'
import References from './References'
import Probabilities from './Probabilities'
import Interactions from './Interactions'
import ImagesTime from './ImagesTime'
import ReadingTime from './ReadingTime'
import Cids from './Cids'
import BookVectorization from './BookVectorization'
import ContentVectorization from './ContentVectorization'
import VectorizationStatus from './VectorizationStatus'
import ContentsList from './ContentsList'
import BookVectorSearch from './BookVectorSearch'

export {
  AtcClassifications,
  Content,
  ContentEdit,
  InteractionsType,
  DcbNames,
  Interactions,
  Laboratories,
  MedicationClassification,
  NotFound,
  NotPermission,
  Login,
  Users,
  References,
  ResetPassword,
  Severities,
  Specialities,
  Medications,
  MedicationsTypes,
  Probabilities,
  Keywords,
  Authors,
  Ratings,
  RatingDetails,
  PreRegistration,
  Profiles,
  ImagesTime,
  ReadingTime,
  Cids,
  BookVectorization,
  ContentVectorization,
  VectorizationStatus,
  ContentsList,
  BookVectorSearch,
}



// WEBPACK FOOTER //
// ./src/containers/index.js